import { Component } from '@angular/core';
import { ScrollService } from '../../splash-service';
import { NAV_OPTIONS } from '../../splash-page/splash.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  navOptions = NAV_OPTIONS;
  date: number = new Date().getFullYear();

  constructor(private scrollService: ScrollService) {}
  
  scrollTo(componentId: string) {
    this.scrollService.triggerScroll(componentId);
  }

}
